import { API } from "../utils/constants";
import { makeApiCall } from "./api-service";

type LiveReportServiceParams = {
    urlParams: string;
    bodyParams: any;
    method?: 'GET' | 'PUT' | 'POST' | 'DELETE';
    withUserId?: boolean;
    responseType?: 'JSON' | 'string'
}

export type CreateAuditLogParams = {
    logModule: string;
    logAction: string;
    attributeName: string;
    message: string;
};

export const liveReportService = async ({ urlParams, bodyParams, method = 'POST', withUserId = false, responseType = "JSON", }: LiveReportServiceParams): Promise<any> => {
    let URL = urlParams ? `${API.LIVE_API_URL}/${urlParams}` : API.LIVE_API_URL;
    const { status, response } = await makeApiCall(URL, method, bodyParams, withUserId);
    return responseType === 'string' ? response : status ? response?.json() : response;
}

export const createAuditLog = async ({
    logModule,
    logAction,
    attributeName,
    message,
}: CreateAuditLogParams): Promise<void> => {
    try {
        const bodyParams = {
            logModule,
            logAction,
            logDescription: JSON.stringify({
                message_view: message,
            }),
            attributeName,
        };
        await liveReportService({ urlParams: 'auditLog', bodyParams });
    } catch (error) {
        console.error('Error recording audit log:', error);
    }
};
